import axios from "axios";

const token = '';
const Axios = axios.create({
    baseURL: 'https://uxtech.com.ng/admin/api.php',
    Headers: {
        'Content-Type': "application/json",
        'Authorization': 'bearer '+token
    }
});

export default Axios;